const aws = require("aws-sdk");

const albumBucketName = "frients-smartservice";
const bucketRegion = "ap-northeast-2";
const IdentityPoolId = "ap-northeast-2:58dd1fe3-0e1b-4b18-8e10-18c4f9172bc5";

aws.config.update({
  region: bucketRegion,
  credentials: new aws.CognitoIdentityCredentials({
    IdentityPoolId: IdentityPoolId,
  }),
});
const s3 = new aws.S3({});

const s3Image = {
  state: {
    path: null,
    imgPath: null,
    success: false,
  },
  mutations: {
    upload(state, { path }) {
      state.success = true;
      state.imgPath = path;
      console.log(state.imgPath, state.success);
      state.path = null;
    },
    remove(state) {
      state.success = false;
      state.imgPath = null;
    },
  },
  actions: {
    async uploadImage({ commit }, { file }) {
      console.log(commit);

      var date = new Date();
      var yyyy = date.getFullYear();
      var mm =
        Number(date.getMonth()) + Number(1) > 9
          ? Number(date.getMonth()) + Number(1)
          : "0" + (Number(date.getMonth()) + Number(1));
      var dd = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();

      var today = yyyy + "" + mm + "" + dd;

      this.fileType = file.name.substring(
        file.name.lastIndexOf("."),
        file.name.length
      );
      var path = today + "/" + new Date().getTime() + this.fileType;

      console.log(path);

      // console.log('store : ',)
      s3.upload(
        {
          Bucket: albumBucketName,
          Key: path,
          ContentType: file.type,
          Body: file,
          ACL: "public-read",
        },
        function (err, data) {
          if (err) {
            console.log(data);
            console.log(err);
            return alert("업로드 중 오류가 발생했습니다: ", err.message);
          }

          commit("upload", {
            path: path,
          });
        }
      );
    },
    async removeImage({ commit }, { file }) {
      console.log(commit, this.state.imgPath, this.state.path, file);

      console.log("store : ");
      s3.deleteObject(
        {
          Bucket: albumBucketName,
          Key: file,
        },
        function (err, data) {
          if (err) {
            console.log(err);
            console.log(data);
            return alert("삭제 중 오류가 발생했습니다: ", err.message);
          }

          commit("remove");
        }
      );
    },
  },
};

export default s3Image;
